<div class="raptor-sidebar-section-default-container form-typography padding-small">
  <h3 class="raptor-sidebar-section-heading hide-for-medium-down" [innerHTML]="section.heading"></h3>

  <div
    *ngFor="let group of section.settings.groups"
    class="raptor-sidebar-section-group-container"
    [ngClass]="{
      'mobile-default': !group.collapse_in_tiny_view,
      'mobile-first-visible-collapsed': group.firstShownMobile === true
    }"
  >
    <div class="raptor-sidebar-section-group-panel">
      <div *ngIf="group.elements"  class="raptor-sidebar-section-group-elements-container">
        <div *ngIf="group.heading" class="margin-bottom-xxsmall hide-for-medium-down">
          <label>{{ group.heading }}</label>
        </div>

        <ng-container *ngFor="let groupElement of group.elements">
          <ng-container *ngFor="let element of section.elements; index as i;">
            <ng-container *ngIf="groupElement === element.key">

              <div [ngSwitch]="element.layout">
                <ng-container *ngSwitchCase="'review'">
                  <open-raptor-question-review [element]="element" [form]="form" [context]="'sidebar'"></open-raptor-question-review>
                </ng-container>

                <ng-container *ngSwitchDefault>
                  <open-raptor-question [question]="element" [form]="form" [submitted]="raptorStepService.submitted" [classes]="i === 0 ? 'padding-none' : ''"></open-raptor-question>
                </ng-container>
              </div>

            </ng-container>
          </ng-container>
        </ng-container>
      </div>

      <div *ngIf="group.component">
        <ng-container class="raptor-sidebar-group" [ngSwitch]="group.component">
          <div *ngSwitchCase="'active_price'" class="component-container">
            <strong class="show-for-medium-down text-left raptor-sidebar-group-heading strong-small" [innerHTML]="section.heading"></strong>
            <open-raptor-component [form]="form" [type]="group.component" [config]="group"></open-raptor-component>
          </div>
          <div *ngSwitchDefault class="component-container">
            <open-raptor-component [form]="form" [type]="group.component" [config]="group"></open-raptor-component>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- ERRORS - show errors in FormData -->
  <div *ngIf="section.errors" class="open-form-info is-error padding-medium margin-top-medium">
    <p class="text-left" *ngFor="let error of section.errors" [innerHTML]="error"></p>
  </div>

</div>
